var S = /* @__PURE__ */ ((C) => (C.Js = "JAVASCRIPT", C.Css = "CSS", C))(S || {});
export {
  S as ExternalResourceTypes
};
//# sourceMappingURL=index3.js.map
